import * as Yup from "yup";
import { CAMPAIGN_LIMITS, ASSET_LIMITS } from "./utils";

const nameSchema = Yup.string()
    .trim()
    .required("Name is required")
    .min(1, "Name is required")
    .max(CAMPAIGN_LIMITS.name, `Max ${CAMPAIGN_LIMITS.name} characters`);

const descriptionSchema = Yup.string()
    .trim()
    .max(CAMPAIGN_LIMITS.description, `Max ${CAMPAIGN_LIMITS.description} characters`)
    .nullable();

const datesSchema = {
    startDatetime: Yup.date().typeError("Invalid date").required("Starts is required"),
    endDatetime: Yup.date()
        .typeError("Invalid date")
        .required("Finishes is required")
        .min(Yup.ref("startDatetime"), "Finishes must be after Starts"),
};

export const basicCampaignSchema = Yup.object().shape({
    name: nameSchema,
    description: descriptionSchema,
    ...datesSchema,
});

const assetSchema = Yup.object().shape({
    text1: Yup.string().trim().max(ASSET_LIMITS.text1, `Max ${ASSET_LIMITS.text1} characters`).nullable(),
    text2: Yup.string().trim().max(ASSET_LIMITS.text2, `Max ${ASSET_LIMITS.text2} characters`).nullable(),
    text3: Yup.string().trim().max(ASSET_LIMITS.text3, `Max ${ASSET_LIMITS.text3} characters`).nullable(),
    imageUrl: Yup.string().required("Image is required"),
    onImageClickUrl: Yup.string().url("Must be a valid URL").nullable(),
});

export const editCampaignSchema = Yup.object().shape({
    name: nameSchema,
    description: descriptionSchema,
    ...datesSchema,
    assets: Yup.array().of(assetSchema),
});
